import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from '@bancobarigui/barihaus';

import { providerUserService } from '@/services/providerUser.service';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';
import { useAlertContext } from '@/contexts/alert.context';

export function useProviderUserEdit() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const { id: userId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { handleError } = useErrorHandler();
  const { notify } = useAlertContext();

  const loadUserData = async () => {
    if (!userId) {
      notify({
        type: 'error',
        message: 'ID do usuário não fornecido',
      });
      navigate('/provider-list');
      return;
    }

    setLoading(true);
    try {
      const user = await providerUserService.getProviderUserById(userId);

      form.setFieldsValue({
        name: user.name,
        email: user.email,
        phone: user.phoneNumber,
        roles: user.roles?.map(r => r.id) || [],
        providerIds: user.providerId ? [user.providerId] : [],
      });
    } catch (error) {
      handleError(error, 'Erro ao carregar dados do usuário');
      navigate('/provider-list');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    if (!userId) return;

    setSubmitting(true);
    try {
      const [providerId] = values.providerIds || [];

      await providerUserService.updateProviderUser(userId, {
        email: values.email,
        name: values.name,
        phoneNumber: values.phone,
        providerId: providerId || null,
        roleIds: values.roles || [],
      });

      notify({
        type: 'success',
        message: 'Usuário atualizado com sucesso!',
      });
      navigate('/provider-list');
    } catch (error) {
      handleError(error, 'Erro ao atualizar usuário');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/provider-list');
  };

  useEffect(() => {
    loadUserData();
  }, [userId]);

  return {
    form,
    loading,
    submitting,
    handleSubmit,
    handleCancel,
  };
}
